import styled, { css } from "styled-components";

import { BoxSizingStyle } from "../BoxSizingStyle";

interface IStyledProgressBar {
  $color?: string;
  $height?: number;
  $width?: number;
}

export const StyledProgressBar = styled.div<IStyledProgressBar>`
  ${BoxSizingStyle}

  ${(props) =>
    props.$width
      ? css`
          width: ${props.$width}%;
        `
      : css`
          width: 100%;
        `}

  ${(props) =>
    props.$color
      ? css`
          background-color: ${props.$color};
        `
      : css`
          background-color: var(--color-theme-300);
        `}
`;

StyledProgressBar.displayName = "StyledProgressBar";

export const StyledProgressBarProgress = styled.div<IStyledProgressBar>`
  ${(props) =>
    props.$height
      ? css`
          height: ${props.$height}px;
        `
      : css`
          height: 3px;
        `}

  ${(props) =>
    props.$color
      ? css`
          background-color: ${props.$color};
        `
      : css`
          background-color: var(--color-secondary);
        `}
`;

StyledProgressBarProgress.displayName = "StyledProgressBarProgress";
